export default __webpack_public_path__ + "static/media/story4.b535dbd9.jpeg";